<template>
  <div v-if="paymentLog">
    <!--预收运费弹框-->
    <PaymentFeesDialog
      v-if="showPaymentFeesDialog"
      :showPaymentFeesDialog="showPaymentFeesDialog"
      :orderNo="payData.orderNo"
      @yufeidaofuSuccess="yufeidaofuSuccess"
      @yushouyunfeiSuccess="yushouyunfeiSuccess"
      @closePaymentFeesDialog="closePaymentFeesDialog"
    />
    <!-- 付款弹出框 -->
    <FreightProcure2Pay
      v-if="freightVisiblePay"
      :dialogVisiblePay="freightVisiblePay"
      :orderId="payData.orderId"
      :campusId="payData.campusId"
      :orderNo="payData.orderNo"
      :orderType="orderType"
      @submitPay="submitPay"
      @cancelSubitPay="cancelSubitPay"
      @closeProcure2Pay="closeProcure2Pay"
      @bankRransferPay="bankRransferPay"
    />
    <!-- 付款弹出框 -->
    <Procure2Pay
      v-if="dialogVisiblePay"
      :dialogVisiblePay="dialogVisiblePay"
      :payData="payData"
      :orderId="payData.orderId"
      :orderType="orderType"
      @submitPay="submitPay"
      @cancelSubitPay="cancelSubitPay"
      @closeProcure2Pay="closeProcure2Pay"
      @bankRransferPay="bankRransferPay"
    />
    <!--微信、支付宝支付-->
    <Procure3Pay
      v-if="procure3PayDialog"
      :procure3PayDialog="procure3PayDialog"
      :elsePayMoney="formLabelAlign.elsePayMoney"
      :Choice="payType"
      :orderNo="payData.orderNo"
      :orderType="orderType"
      @agentPaySuccess="agentPaySuccess"
      @paySuccess="paySuccess"
      @closeProcure3PayDialog="closeProcure3PayDialog"
    />
    <!--付款-对公转账-->
    <BankRransferModal
      v-if="bankRransferDialogVisible"
      :bankRransferDialogVisible="bankRransferDialogVisible"
      :payData="payData"
      :companyInfo="companyInfo"
      :formLabelAlign="formLabelAlign"
      @closeBankRransfer="closeBankRransfer"
      @bankRransferSuccess="bankRransferSuccess"
      :purchaseOrderPay="purchaseOrderPay"
    />
    <!--支付二次确认弹框-->
    <ConfirmDialog
      :dialogVisible="payDialogVisible"
      @dialogCancel="payDialogCancel"
      @dialogConfirm="payDialogConfirm"
    >
      <div class="dialog-content">
        <div class="order-kouchu-wrap">
          <p class="dialog-title">提示</p>
          <p class="kouchu-tips">本次支付将扣除：</p>
          <ul class="kouchu-money-ul">
            <li>
              裂变奖金账户：{{ this.formLabelAlign.voucherAccountPayMoney }}元
            </li>
            <li>现金账户：{{ this.formLabelAlign.accountPayMoney }}元</li>
            <li>金账户：{{ this.formLabelAlign.totalGoldPayMoney }}元</li>
            <li>提货券帐户：{{ this.formLabelAlign.deliveryMoney }}元</li>
          </ul>
        </div>
      </div>
    </ConfirmDialog>
    <!--付款成功或者失败-->
    <el-dialog
      center=""
      :title="payResultTitle"
      custom-class="MyDialog pay-result-dialog"
      :visible.sync="showPayResultDialog"
      :show-close="false"
      width="500px"
    >
      <div class="pay-result">
        <template v-if="isSuccess">
          <img src="@/assets/images/agent/pay_success.png" />
          <p class="result-tips">成功支付￥{{ money }}元</p>
        </template>
        <template v-else>
          <img src="@/assets/images/agent/pay_fail.png" />
          <p class="result-tips">未能成功支付￥{{ money }}元</p>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hidePayResultDialog"
          >我知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FreightProcure2Pay from "@/components/FreightProcure2Pay";
import Procure3Pay from "@/components/Procure3Pay";
import BankRransferModal from "@/components/BankRransferModal";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import PaymentFeesDialog from "@/components/PaymentFeesDialog.vue";
import { queryCompanyInfo } from "@/api/AgentAccount";
import Procure2Pay from "@/components/Procure2Pay";

import { purchaseOrderPay,creditOrderPay } from "@/api/AccountInterface";
export default {
  props: {
    orderType: {
      type: String,
      default: "online"
    },
    payData: {
      type: Object,
      default: () => {},
    },
    callBackFn: {
      type: Function,
      default: () => {},
    },
    purchaseOrderPay: {
      type: Boolean, // 对公支付接口区分
      default: true,
    },
    payApi: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      paymentLog: false, // 支付弹框
      dialogVisiblePay: false, // 普通支付弹框
      freightVisiblePay: false, // 支付运费
      procure3PayDialog: false, // 微信、支付宝支付
      bankRransferDialogVisible: false, // 对公转账
      payDialogVisible: false, // 支付二次确认弹框
      showPayResultDialog: false, // 支付成功或者失败
      showPaymentFeesDialog: false, // 预收费弹框
      formLabelAlign: {}, // 支付弹框数据
      agentAccountObj: {},
      companyInfo: {}, // 公司信息
      payType: "", // 支付方式
      money: "", // 支付金额
      isSuccess: false, // 支付成功或者失败
      payResultTitle: "", // 支付成功或者失败标题
      dialogPayType: "", //
    };
  },
  components: {
    FreightProcure2Pay,
    ConfirmDialog,
    Procure3Pay,
    BankRransferModal,
    PaymentFeesDialog,
    Procure2Pay,
  },
  mounted() {
    this.queryCompanyInfo();
    console.log("子组件");
  },
  methods: {
    /**
     * @param dict 打开支付弹框的类型
     * showPaymentFeesDialog 预收费弹框
     * dialogVisiblePay 直接支付弹框
     */
    openPaymentDialog(dict = "dialogVisiblePay") {
      this.dialogPayType = "";
      this.procure3PayDialog = false;
      this[dict] = true;
      this.paymentLog = true;
    },
    closePaymentFeesDialog() {
      this.paymentLog = false;
    },
    async queryCompanyInfo() {
      try {
        let { data, code, message } = await queryCompanyInfo();
        if (code === 0) {
          this.companyInfo = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        // 捕获并处理 queryCompanyInfo 函数可能抛出的异常
        console.error(error);
        this.$message.error(error.message);
      }
    },
    // 确认开始支付
    submitPay(fromPayData, payType, agentAccountObj, type) {
      console.log("fromPayData", fromPayData, type);
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
      this.formLabelAlign = fromPayData;
      this.payType = payType;
      if (type != "onlyAgentPay") {
        this.payDialogVisible = true;
      }
      this.payDialogVisible = true;
      if (type == "submitAndAgentPay") {
        this.dialogPayType = type;
      } else if (type == "paymentFN") {
        this.handleClick(this.payData);
        this.dialogPayType = type;
      } else if (type == "onlyAgentPay") {
        // 只有现金支付
        this.agentPay();
      }
    },
    // 支付宝、微信
    agentPay() {
      this.payDialogVisible = false;
      this.procure3PayDialog = true;
    },
    paySuccess(money, isSuccess) {
      this.payResultTitle = isSuccess ? "支付成功" : "支付失败";
      this.money = money;
      this.isSuccess = isSuccess;
      this.showPayResultDialog = true;
    },
    agentPaySuccess() {
      this.callBackFn();
      this.procure3PayDialog = false;
    },
    handleClick(row) {
      console.log("xxdsds-----", row);
      // this.payData = row;
      this.procure3PayDialog = false;
      checkPurchaseOrderPay({ orderNo: row.orderNo }).then((ret) => {
        if (ret.code === 0) {
          console.log("xxdsds----- 11122");
          this.dialogVisiblePay = true;
        } else {
          this.$message.error(ret.message);
        }
      });
    },
    payDialogConfirm() {
      this.submit();
    },
    // 对公转账
    bankRransferPay(formLabelAlign, payType, agentAccountObj) {
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
      this.bankRransferDialogVisible = true;
      this.formLabelAlign = formLabelAlign;
      this.payType = payType;
      this.agentAccountObj = agentAccountObj;
      console.log(
        "this.bankRransferDialogVisible",
        this.bankRransferDialogVisible
      );
    },
    // 提交订单
    submit() {
      const {
        accountPayMoney,
        deliveryMoney,
        voucherAccountPayMoney,
        totalGoldPayMoney,
        elsePayMoney,
      } = this.formLabelAlign;
      const params ={
        agentMoney: accountPayMoney, //1
        realTimeMoney: 0,
        bankInfo: {
          fileUrl: [],
          money: 0,
          paySysNo: "",
          payTime: "",
          remark: "",
        },
        orderNo: this.payData.orderNo, //-1
        voucherAccountMoney: voucherAccountPayMoney, // 2
        goldMoney: totalGoldPayMoney, //
        goldAccount: this.agentAccountObj.goldAccount, // 2
        halfGoldAccount: this.agentAccountObj.halfGoldAccount, // 2
        payMethod: this.payType,
        deliveryMoney: deliveryMoney,
      }
      console.log(this.payApi,'====');
      
      if(this.payApi == "loan"){
        this.creditOrderPay(params)
        return
      }
      purchaseOrderPay(params).then((ret) => {
        if (ret.code == 0) {
          if (this.dialogPayType == "submitAndAgentPay") {
            this.agentPay();
          } else {
            this.$message.success("付款成功");
            this.payDialogVisible = false;
            this.callBackFn();
          }
        } else {
          // this.subCK = true;
          this.$message.error(ret.message || "付款失败");
        }
      });
      // }
    },
    // 赊货支付接口
    creditOrderPay(params){
      creditOrderPay(params).then(ret => {
        console.log("retttttttttttttttttttt", ret);
        if (ret.code == 0) {
          if (this.dialogPayType == "submitAndAgentPay") {
            this.agentPay();
          } else {
            this.payDialogVisible = false;
            this.callBackFn();
          }
          this.$message.success("付款成功");
        } else {
          // this.subCK = true;
          this.$message.error(ret.message || "付款失败");
        }
      });
    },
    // 运费到付
    yufeidaofuSuccess() {
      this.showPaymentFeesDialog = false;
      this.freightVisiblePay = true;
    },
    // 预收运费
    yushouyunfeiSuccess() {
      this.showPaymentFeesDialog = false;
      this.freightVisiblePay = true;
    },
    closePaymentFeesDialog() {
      this.showPaymentFeesDialog = false;
    },
    cancelSubitPay() {
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
    },
    closeProcure2Pay() {
      this.dialogVisiblePay = false;
      this.freightVisiblePay = false;
    },
    closeProcure3PayDialog() {
      this.procure3PayDialog = false;
    },
    closeBankRransfer() {
      this.bankRransferDialogVisible = false;
    },
    // 对公转账成功
    bankRransferSuccess() {
      this.bankRransferDialogVisible = false;
      this.callBackFn();
    },
    // 二次支付弹框取消
    payDialogCancel() {
      this.payDialogVisible = false;
    },
    hidePayResultDialog() {
      this.showPayResultDialog = false;
      this.procure3PayDialog = false;
      this.callBackFn();
    },
  },
};
</script>
<style scoped lang="scss">
.order-kouchu-wrap {
  text-align: center;
}
</style>
